import { render, staticRenderFns } from "./configBucketForm.vue?vue&type=template&id=09203bd0"
import script from "./configBucketForm.vue?vue&type=script&lang=js"
export * from "./configBucketForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports